import React, { useState } from 'react'
import SearchDropdown from '@SiteComponents/SearchDropdown'
import Remove from '@Images/project_setup_form_remove_language.svg'
import Alert from '@Images/project_setup_form_alert.svg'

import './ProjectVersionLanguageTts.scss'

interface ProjectVersionLanguageTtsProps {
  readonly newProjectVersionLanguage: string
  readonly availableProjectVersionLanguages: string[]
  readonly showAlert: boolean
  setNewProjectVersionLanguage(newProjectVersionLanguage: string): void
  handleFetchTranslationLanguages(): void
}

const ProjectVersionLanguageTts: React.FC<ProjectVersionLanguageTtsProps> = props => {
  const {
    availableProjectVersionLanguages,
    newProjectVersionLanguage,
    showAlert,
  } = props

  const [showButtons, setShowButtons] = useState(true)

  const handleRemoveProjectVersionLanguage = () => {
    props.setNewProjectVersionLanguage('')
  }

  const renderButtons = () => {
    return (
      <div className="ProjectVersionLanguageTts__buttons">
        <div
          className="ProjectVersionLanguageTts__button"
          onClick={handleRemoveProjectVersionLanguage}
        >
          <Remove />
        </div>
      </div>
    )
  }

  const renderAlert = () => {
    return (
      <div className="SetupProjectPopupTts__alert">
        <Alert />
        You need to select the source language of your project.
      </div>
    )
  }

  return (
    <div className="ProjectVersionLanguageTts">
      <div
        className="ProjectVersionLanguageTts__main ProjectVersionLanguageTts__element"
        id="project_version_language_tts_main"
      >
        <SearchDropdown
          availableOptions={availableProjectVersionLanguages}
          selectedOption={newProjectVersionLanguage}
          setSelectedOption={props.setNewProjectVersionLanguage}
          showAlert={showAlert}
          setShowButtons={setShowButtons}
          classNameForClickOutsideListener="ProjectVersionLanguageTts__element"
          idNameOfParentContainer="project_version_language_tts_main"
          placeholderText="Select the source language..."
          noOptionFoundText="No language found"
        />
        {showButtons && renderButtons()}
      </div>
      {showAlert && renderAlert()}
    </div>
  )
}

export default ProjectVersionLanguageTts
